// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Blog: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
            <g fill="none" fillRule="evenodd">
                <circle cx="22" cy="22" r="21.5" stroke="#FFF" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M14.5 12h7.247c2.823 0 4.919.424 6.288 1.271 1.368.848 2.053 2.167 2.053 3.957 0 1.178-.298 2.184-.895 3.017-.597.833-1.383 1.37-2.36 1.609v.143c1.29.345 2.222.92 2.8 1.724.578.804.867 1.848.867 3.131 0 1.906-.708 3.407-2.124 4.503C26.959 32.452 25.029 33 22.586 33H14.5V12Zm6 8h1.603c.763 0 1.353-.178 1.77-.534.418-.357.627-.886.627-1.588 0-1.252-.835-1.878-2.505-1.878H20.5v4Zm0 4v4h2.145c1.903 0 2.855-.678 2.855-2.033 0-.634-.255-1.12-.764-1.459-.51-.339-1.247-.508-2.214-.508H20.5Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Blog);
